module.exports = __webpack_public_path__ + "img/logo-symbol.1eb09568.svg";